import { Stack, Text, Button } from '@mantine/core';
import { Settings } from 'react-feather';

interface CompensationZeroStateProps {
  hasCoaches: boolean;
  isConfigured: boolean;
  audienceTypeLabel?: string;
  onConfigure: () => void;
}

export function CompensationZeroState({
  hasCoaches,
  isConfigured,
  audienceTypeLabel,
  onConfigure,
}: CompensationZeroStateProps) {
  if (isConfigured && !hasCoaches) {
    return (
      <Stack align="center" py="xl" gap="sm">
        <Text fw={600}>
          {audienceTypeLabel} &middot; Configured
        </Text>
        <Text c="dimmed" size="sm" ta="center" maw={400}>
          Compensation configured. Add potential coaches to see estimated compensation.
        </Text>
        <Button
          variant="light"
          leftSection={<Settings size={16} />}
          onClick={onConfigure}
          mt="xs"
        >
          Configure Compensation
        </Button>
      </Stack>
    );
  }

  return (
    <Stack align="center" py="xl" gap="md">
      <Text c="dimmed" size="sm" ta="center" maw={400}>
        Configure compensation to get started. Set the audience type and review rates for this
        cohort.
      </Text>
      <Button leftSection={<Settings size={16} />} onClick={onConfigure}>
        Configure Compensation
      </Button>
    </Stack>
  );
}
